import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../../../services/subscription.service';
import { ProfileService } from '../../../services/profile.service';
import { AuthenticationService } from '../../../authentication.service';
import { SharedDataService } from '../../../services/shared-data.service';
import { ModalService } from '../../../services/modals.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { onPhoneNumberEntered } from '../../../shared/helper-functions';
import { arrayIsDefinedAndContainsKey } from '../../../shared/array-functions';
import { openModal, closeModal, closeModalWithoutRemovingBackdrop } from '../../../shared/modal-functions';
import { subscriptionViewSpanish } from '../subscription.static.data';
declare var jQuery: any;

@Component({
  selector: 'app-activate-digital-access',
  templateUrl: './activate-digital-access.component.html',
  styleUrls: ['../../../app.component.css']
})
export class ActivateDigitalAccessComponent implements OnInit {
  // Static data
  subscriptionView: any;
  // Validation
  invalidInputCombination: boolean;
  activateDigitalAccessResponse: string;
  // Control view
  openModal: any;
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  onPhoneNumberEntered: any;
  findSubscriptionCompleted: boolean;
  // User data
  customerId: string;
  userInfo: UserInfo = {
    name: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    zipcode: ''
  };

  constructor(public subscriptionService: SubscriptionService, private sharedDataService: SharedDataService, private profileService: ProfileService, private authenticationService: AuthenticationService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService) {
    this.subscriptionView = subscriptionViewSpanish;
    this.invalidInputCombination = false;
    this.openModal = openModal;
    this.closeModal = closeModal;
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
    this.onPhoneNumberEntered = onPhoneNumberEntered;
    this.findSubscriptionCompleted = true;
  }

  ngOnInit() {
  }

  findSubscription() {
    this.sharedDataService.userInfo = this.userInfo;
    this.invalidInputCombination = false;
    if (this.userInfo.name && this.userInfo.lastName && ((this.userInfo.phoneNumber && this.userInfo.zipcode) || this.userInfo.email)) {
      this.findSubscriptionCompleted = false;
      const payload = {
        FirstName: this.userInfo.name,
        LastName: this.userInfo.lastName,
        Email: this.userInfo.email,
        Phone: this.userInfo.phoneNumber,
        DeliveryZipCode: this.userInfo.zipcode
      };
      this.subscriptionService.findSubscription(payload).subscribe(
        (response) => {
          if (arrayIsDefinedAndContainsKey(response, 'CMS_SAM_GetCustID_FindSubscription')) {
            this.customerId = response['CMS_SAM_GetCustID_FindSubscription'][0]['CustID'];
            this.sharedDataService.customerId = response['CMS_SAM_GetCustID_FindSubscription'][0]['CustID'];
            if (this.customerId !== null && !this.authenticationService.gigyaId) { // Subscription found but user is not logged in 
              this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Encontramos_Suscripcion');
              this.openModal('#gigyaRegisterModal');
              this.authenticationService.registerOrLoginFromActivateSubscription();
              this.authenticationService.getIsAuthenticated().subscribe((isAuthenticated) => {
                if (isAuthenticated) {
                  this.activateSubscription(true);
                }
              });
            } else if (this.customerId !== null && this.authenticationService.gigyaId) { // Subscription found but user is logged in
              this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Encontramos_Suscripcion');
              this.activateSubscription(false);
            } else if (this.customerId === null) { // Subscription not found
              this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', this.createLabelForSubscriptionNotFoundGAEvent(payload));
              this.activateDigitalAccessResponse = response['CMS_SAM_GetCustID_FindSubscription'][0]['responseText'];
              this.openModal('#subscriptionNotFoundModal');
            }
          }
          this.findSubscriptionCompleted = true;
        },
        (error) => {
          this.openModal('#errorInTransactionModal');
        });
    } else {
      this.invalidInputCombination = true;
    }
  }

  activateSubscription(isGigyaModalOpen) {
    const payload = {
      GigyaID: this.authenticationService.gigyaId,
      CustID: this.customerId,
      Email: this.authenticationService.userProfile.email,
    };
    this.subscriptionService.activateSubscription(payload).subscribe(
      (response) => {
        if (arrayIsDefinedAndContainsKey(response, 'CMS_SAM_GetCustID_ActivateSubscription')) {
          isGigyaModalOpen ? this.closeModal('#gigyaRegisterModal') : '';
          if (response['CMS_SAM_GetCustID_ActivateSubscription'][0]['success'] === 1) {
            this.openModal('#activateSuccessResponseModal');
            this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Thank_You_Page_Activada');
          } else { // Subscription was not activated, display error message
            this.openModal('#activateErrorResponseModal');
            this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmando_Error_en_Activacion');
          }
        }
      },
      (error) => {
        this.openModal('#errorInTransactionModal');
      });
  }

  closeModals() {
    this.modalService.toggle('activate-digital-access');
    this.closeModal('#activateDigitalAccessModal');
    this.closeModal('#activateSuccessResponseModal');
    this.authenticationService.getUserInfo();
  }

  createLabelForSubscriptionNotFoundGAEvent(subscriptionInfo): string {
    let label;
    if (subscriptionInfo.Email === "" && subscriptionInfo.Phone !== "" && subscriptionInfo.DeliveryZipCode !== "") {
      label = 'No_encontramos_Suscripcion_PhoneNumber_Zipcode';
    }
    else if (subscriptionInfo.Email !== "" && subscriptionInfo.Phone !== "" && subscriptionInfo.DeliveryZipCode !== "") {
      label = 'No_encontramos_Suscripcion_Email_PhoneNumber_Zipcode';
    }
    else if (subscriptionInfo.Email !== "" && subscriptionInfo.Phone !== "" && subscriptionInfo.DeliveryZipCode === "") {
      label = 'No_encontramos_Suscripcion_Email_PhoneNumber';
    }
    else if (subscriptionInfo.Email !== "" && subscriptionInfo.Phone === "" && subscriptionInfo.DeliveryZipCode !== "") {
      label = 'No_encontramos_Suscripcion_Email_Zipcode';
    }
    else if (subscriptionInfo.Email !== "" && subscriptionInfo.Phone === "" && subscriptionInfo.DeliveryZipCode === "") {
      label = 'No_encontramos_Suscripcion_Email';
    }
    return label;
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }
}
interface UserInfo {
  name: string,
  lastName: string,
  email: string,
  phoneNumber: string,
  zipcode: string
}




// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/activate-digital-access/activate-digital-access.component.ts